import React, { useEffect, useState } from 'react';
import { Segment, Header, Card, TextArea, Button } from 'semantic-ui-react';

const Dash = () => {
  const [sleep, setSleep] = useState({ psqi: 7, avgHours: 6.5 });
  const [stress, setStress] = useState({ score: 12 });
  const [pvt, setPvt] = useState({ quantile: '<25%' });
  const [summary, setSummary] = useState('');
  const [newNote, setNewNote] = useState('');

  useEffect(() => {
    const generatedSummary = `
Today showed a clear pattern of fluctuating energy and mood. Morning fatigue was partially alleviated by coffee and a short walk. Mid-morning work stress increased tension, while social interaction at lunch boosted mood. Mid-afternoon drowsiness affected focus. Evening exercise improved mood, but watching a show coincided with mild anxiety, likely influenced by the content. Bedtime was later than planned, which may impact tomorrow's energy.

**Follow-up questions:**  
- Are there particular types of content or activities that consistently affect your anxiety?  
- How do exercise, social interactions, and evening habits influence your overall mood and sleep?  
- Is there anything missing from these observations that could help explain mood patterns?`;

    setSummary(generatedSummary);
  }, []);

  const addNote = () => {
    if (newNote.trim() === '') return;
    // Save note if needed
    setNewNote('');
  };

  const cardHeight = 400;
  const cardStyle = {
    height: `${cardHeight}px`,
    minHeight: `${cardHeight}px`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '1em',
    boxShadow: 'none',
    fontSize: '13px',
    marginTop: 0,
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
  };

  const headerStyle = { 
    fontSize: '18px', 
    marginBottom: '12px',  // increased space between header and content
    lineHeight: '1.2', 
    fontWeight: 600
  };

  const subStyle = { 
    fontSize: '18px', 
    color: '#555', 
    whiteSpace: 'pre-line', 
    flex: 1, 
    overflowY: 'auto', 
    marginBottom: '8px' 
  };

  const getBorderColor = (card) => {
    if (card.label === 'Daily Notes') return 'teal';
    if (card.label === 'Vigor/Fatigue') return sleep.psqi > 7 ? 'green' : 'orange';
    if (card.label === 'Stress') return stress.score > 15 ? 'red' : 'orange';
    return 'gray';
  };

  const cardsData = [
    { 
      label: 'Daily Notes', 
      value: null, 
      sub: summary, 
      width: '25%' 
    },
    { 
      label: '2 week assessments', 
      value: null, 
      sub: `Sleep (PSQI): ${sleep.psqi}\nStress (PSS): ${stress.score}`, 
      width: '25%' 
    },
    { 
      label: "Last Night's Sleep Activity", 
      value: null, 
      sub: 'Recovery/Active Ratio:0.5',
      width: '25%' 
    },
    { 
      label: "Today's Activity", 
      value: null, 
      sub: 'Vigilance: <25%\nHRM:0.5',
      width: '25%' 
    },
  ];

  return (
    <Segment
      style={{
        marginTop: '15em',
        padding: '1em',
        borderRadius: '8px',
        backgroundColor: '#fafafa',
      }}
    >
      <Header as="h3" textAlign="center" style={{ marginBottom: '0.8em', fontSize: '18px' }}>
        Dashboard Overview
      </Header>

      <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', flexWrap: 'nowrap' }}>
        {cardsData.map((card, i) => (
          <Card
            key={i}
            style={{
              ...cardStyle,
              width: card.width,
              borderTop: `4px solid ${getBorderColor(card)}`,
              textAlign: "left"
            }}
          >
            <Card.Content style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <div style={headerStyle}>{card.label}</div>
              {card.value !== null && <div style={{ fontSize: '18px', fontWeight: 700, marginBottom: '12px' }}>{card.value}</div>}
              <div style={subStyle}>{card.sub}</div>

              {card.label === 'Daily Notes' && (
                <>
                  <TextArea
                    placeholder="Add a note..."
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                    style={{ width: '100%', boxSizing: 'border-box', marginBottom: '4px' }}
                  />
                  <Button
                    color="teal"
                    size="small"
                    onClick={addNote}
                    style={{ width: '100%' }}
                  >
                    Add Note
                  </Button>
                </>
              )}
            </Card.Content>
          </Card>
        ))}
      </div>
    </Segment>
  );
};

export default Dash;
